"use strict";

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Represents a logged in User and provides the ability to sign transactions as that user.
 */

var User = /*#__PURE__*/function () {
  function User() {
    _classCallCheck(this, User);
  }

  _createClass(User, [{
    key: "returnEosjsTransaction",
    value: function returnEosjsTransaction(wasBroadcast, completedTransaction) {
      if (wasBroadcast) {
        if (completedTransaction.hasOwnProperty('transaction_id')) {
          return {
            wasBroadcast: true,
            transactionId: completedTransaction.transaction_id,
            status: completedTransaction.processed.receipt.status,
            transaction: completedTransaction
          };
        } else if (completedTransaction.hasOwnProperty('code')) {
          return {
            wasBroadcast: true,
            error: {
              code: completedTransaction.code,
              message: completedTransaction.message,
              name: completedTransaction.error.name
            },
            transaction: completedTransaction
          };
        } else {
          return {
            wasBroadcast: true,
            transaction: completedTransaction
          };
        }
      } else {
        return {
          wasBroadcast: false,
          transaction: completedTransaction
        };
      }
    }
  }, {
    key: "buildRpcEndpoint",
    value: function buildRpcEndpoint(endPoint) {
      var rpcEndpointString = "".concat(endPoint.protocol, "://").concat(endPoint.host, ":").concat(endPoint.port);

      if (endPoint.path) {
        var separator = '/';

        if (endPoint.path.startsWith('/')) {
          separator = '';
        }

        rpcEndpointString = "".concat(rpcEndpointString).concat(separator).concat(endPoint.path);
      }

      if (rpcEndpointString.endsWith('/')) {
        rpcEndpointString = rpcEndpointString.substring(0, rpcEndpointString.length - 1);
      }

      return rpcEndpointString;
    }
  }]);

  return User;
}();

exports.User = User;